import { z } from 'zod';

export const EmployeeSchema = z.object({
  firstName: z.string({ message: 'Le prénom est requis' }),
  lastName: z.string({ message: 'Le nom est requis' }),
  email: z
    .string({
      required_error: "L'email est requis",
      invalid_type_error: 'Email incorrect',
    })
    .email(),
  password: z
    .string({
      required_error: 'Le mot de passe est requis',
    })
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
  phoneNumber: z
    .string()
    .regex(
      /^\+?[0-9]+$/,
      'Le numéro de téléphone ne doit contenir que des chiffres ou un + au début',
    )
    .min(5, 'Le numéro de téléphone doit contenir au moins 5 caractères'),
});

export type EmployeeFormData = z.infer<typeof EmployeeSchema>;
